import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { cleanOuter, cleanHtml } from "@/lib/clonerApi";

/** Código: HTML del elemento, CSS de la página y HTML completo. */
export const CodePanel = ({ el, doc, onElementHtml, onPageHtml, version }) => {
  const [elHtml, setElHtml] = useState("");
  const [css, setCss] = useState("");
  const [pageHtml, setPageHtml] = useState("");

  useEffect(() => {
    setElHtml(el ? cleanOuter(el) : "");
    const custom = doc?.getElementById("__fxcustom");
    setCss(custom?.textContent || "");
    setPageHtml(doc ? cleanHtml(doc) : "");
  }, [el, doc, version]);

  const applyCss = () => {
    let tag = doc.getElementById("__fxcustom");
    if (!tag) {
      tag = doc.createElement("style");
      tag.id = "__fxcustom";
      doc.head.appendChild(tag);
    }
    tag.textContent = css;
    onElementHtml(null, true);
    toast.success("CSS aplicado");
  };

  return (
    <div className="p-3 space-y-4" data-testid="code-panel">
      <div>
        <div className="text-[10px] text-white/40 uppercase tracking-wide mb-1">HTML del elemento</div>
        <textarea rows={6} value={elHtml} onChange={(e) => setElHtml(e.target.value)}
          data-testid="code-element"
          className="w-full glass-card px-2 py-1.5 bg-black/50 text-white/85 text-[10px] font-mono outline-none" />
        <button data-testid="code-element-apply" disabled={!el}
          onClick={() => onElementHtml(elHtml)}
          className="glass-btn px-3 py-1.5 rounded-lg text-[10px] mt-1 flex items-center gap-1">
          <Check className="w-3 h-3" /> Aplicar al elemento
        </button>
      </div>
      <div>
        <div className="text-[10px] text-white/40 uppercase tracking-wide mb-1">
          CSS extra de esta página
        </div>
        <p className="text-[10px] text-white/30 mb-1">
          Se añade al final de la página. Las hojas .css originales se editan en «Archivos».
        </p>
        <textarea rows={6} value={css} onChange={(e) => setCss(e.target.value)}
          placeholder=".mi-clase { color: red; }" data-testid="code-css"
          className="w-full glass-card px-2 py-1.5 bg-black/50 text-white/85 text-[10px] font-mono outline-none" />
        <button data-testid="code-css-apply" onClick={applyCss}
          className="glass-btn px-3 py-1.5 rounded-lg text-[10px] mt-1 flex items-center gap-1">
          <Check className="w-3 h-3" /> Aplicar CSS
        </button>
      </div>
      <div>
        <div className="text-[10px] text-white/40 uppercase tracking-wide mb-1">HTML completo</div>
        <textarea rows={8} value={pageHtml} onChange={(e) => setPageHtml(e.target.value)}
          data-testid="code-page"
          className="w-full glass-card px-2 py-1.5 bg-black/50 text-white/85 text-[10px] font-mono outline-none" />
        <button data-testid="code-page-apply" onClick={() => onPageHtml(pageHtml)}
          className="glass-btn px-3 py-1.5 rounded-lg text-[10px] mt-1 flex items-center gap-1">
          <Check className="w-3 h-3" /> Aplicar a la página
        </button>
      </div>
    </div>
  );
};
